/** @format */
import { css } from 'styled-components';

import { mobile } from '@toucan/client/global/application';

import { SignUpFormStyleProps } from './index';

/**
 * Base styles for the sign up form component
 *
 * @param {SignUpFormStyleProps} props The sign up form properties object
 * */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
const baseStyles = (props: SignUpFormStyleProps) => css`
    padding: 0 3.6rem;
    text-align: left;

    .modal & {
        padding: 0;
    }

    .create-account-heading {
        margin-bottom: var(--layout-spacing-16);
    }

    .text-center {
        text-align: center;
    }

    .grid-container {
        padding: 1.2rem 0;
        text-align: left;
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto auto auto auto auto;
        grid-template-areas: 'first-name last-name' 'email-address email-address' 'password password' 'receive-email-marketing receive-email-marketing' 'submit submit';
    }

    .first-name {
        margin-right: var(--layout-spacing-16);
    }

    .email-address {
        grid-area: email-address;
    }

    .first-name {
        grid-area: first-name;
    }

    .last-name {
        grid-area: last-name;
    }

    .password {
        grid-area: password;
    }

    .receive-email-marketing {
        grid-area: receive-email-marketing;
        display: flex;
        margin-bottom: var(--layout-spacing-12);
    }

    .submit {
        text-align: center;
        grid-area: submit;

        button {
            width: 21.6rem;
        }

        .error-message {
            margin-bottom: 2.4rem;
        }
    }

    .notice {
        font-size: 1.2rem;
        color: var(--colors-text-primary);
        margin-bottom: 0;
        text-align: center;
    }
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

/**
 * Mobile styles for the sign up form component
 *
 * */
const mobileStyles = () => css`
    padding: 0;

    .grid-container {
        display: block;
    }

    .first-name,
    .password {
        margin-right: 0;
    }

    .last-name,
    .confirm-password {
        margin-left: 0;
    }
`;

/**
 * The sign up form component styles
 *
 * @param {SignUpFormStyleProps} props The sign up form properties object
 * */
export const styles = (props: SignUpFormStyleProps) => css`
    ${baseStyles(props)}
    ${mobile(mobileStyles())}
`;
